export default __webpack_public_path__ + "static/media/influencer.344ebb6d.svg";